const About = () => import('./views/About');
const ChildList = () => import('./views/ChildList');
const Home = () => import('./views/Home');
const Settings = () => import('./views/Settings');
const Tips = () => import('./views/Tips');

const routes = [
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/childList',
    name: 'childList',
    component: ChildList,
  },
  {
    path: '/about',
    name: 'about',
    component: About,
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
  },
  {
    path: '/tips',
    name: 'tips',
    component: Tips,
  }
];

export default (router) => {
  routes.forEach((element) => {
    router.addRoute('main', element);
  });
};
